import React, { useState, useEffect } from 'react';

const STORAGE_KEY = 'loa_cookie_consent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) {
      setVisible(true);
    } else if (saved === 'accepted' && window.gtag) {
      window.gtag('consent', 'update', { analytics_storage: 'granted' });
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    if (window.gtag) {
      window.gtag('consent', 'update', { analytics_storage: 'granted' });
    }
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(STORAGE_KEY, 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-brand-deep text-bone shadow-xl print:hidden">
      <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <p className="text-sm leading-relaxed text-bone/90">
          We use cookies to understand how visitors use our site and improve your experience.
          By clicking <strong className="text-bone">Accept</strong>, you consent to analytics cookies.
        </p>
        <div className="flex items-center gap-3 shrink-0">
          <button
            onClick={decline}
            className="text-sm font-medium text-bone/60 hover:text-bone transition-colors px-3 py-1.5"
          >
            Decline
          </button>
          <button
            onClick={accept}
            className="text-sm font-medium bg-bone text-brand-deep px-5 py-1.5 rounded-full hover:bg-cream transition-colors"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
